import { GET_COMPETENCIES } from '@/api/master-data/competency/competency';
import { GET_ROLE_COMPETENCIES } from '@/api/master-data/role-competency/role-competency';
import { GET_TRAINING_TYPE } from '@/api/master-data/training-type/training-type';
import trainingCategoryAPI from '@/api/master-data/training-category/training-category';
import { GET_LSP } from '@/api/lsp/lsp';
import { GET_TRAINING_PROVIDER } from '@/api/master-data/training-provider/training-provider';
import filterAPI from '@/api/master-data/course-mapping/filter-api';
import positionLevelAPI from '@/api/master-data/position-level/position-level';

const state = {
  // Options for Step 1
  typeOptions: ['Internal', 'External', 'Thematic'],
  roleOptions: [],
  competencyOptions: [],
  matrixKPLHOptions: [
    { label: 'KPLH', value: 'KPLH' },
    { label: 'NON KPLH', value: 'NON_KPLH' }
  ],
  
  // Loading states Step 1
  isLoadingRoles: false,
  isLoadingCompetencies: false,

  // ==================== Step 2 ====================
  // Options for Step 2
  courseTypeOptions: [], // Will be loaded from API
  categoryOptions: [], // Will be loaded from API
  stemMainOptions: ['STEM', 'Non STEM'],
  stemSubOptions: {
    'STEM': ['Science', 'Technology', 'Engineering', 'Math'],
    'Non STEM': [
      'General Management & Leadership',
      'Legal',
      'Human Resources',
      'Health, Safety, Environment',
      'Supply Chain Management',
      'Sales & Marketing'
    ]
  },
  // Certificate Validity Period Options
  yearOptions: [
    { label: '0 Year', value: 0 },
    { label: '1 Year', value: 1 },
    { label: '2 Years', value: 2 },
    { label: '3 Years', value: 3 },
    { label: '4 Years', value: 4 },
    { label: '5 Years', value: 5 }
  ],
  monthOptions: [
    { label: '0 Month', value: 0 },
    { label: '1 Month', value: 1 },
    { label: '2 Months', value: 2 },
    { label: '3 Months', value: 3 },
    { label: '4 Months', value: 4 },
    { label: '5 Months', value: 5 },
    { label: '6 Months', value: 6 },
    { label: '7 Months', value: 7 },
    { label: '8 Months', value: 8 },
    { label: '9 Months', value: 9 },
    { label: '10 Months', value: 10 },
    { label: '11 Months', value: 11 },
    { label: '12 Months', value: 12 }
  ],

  // Loading states Step 2
  isLoadingCourseTypes: false,
  isLoadingCategories: false,

  // ==================== Step 3 ====================
  // Options for Step 3
  platformOptions: [
    { value: 'My Learning', label: 'My Learning' },
    { value: 'Ugems University', label: 'BIB Academy' },
    { value: 'Other', label: 'Other' }
  ],
  lspOptions: [], // Provider Name (LSP) - from API
  trainingProviderOptions: [], // Training Institution (LDP) - from API

  // Loading states Step 3
  isLoadingLSP: false,
  isLoadingTrainingProvider: false,

  // ==================== Step 4 ====================
  // Options for Step 4
  departmentOptions: [], // from API
  divisionOptions: [],   // from API (needs department param)
  organizationLevelOptions: [], // from API (conditional is_partner param)

  // Loading states Step 4
  isLoadingDepartments: false,
  isLoadingDivisions: false,
  isLoadingOrganizationLevels: false,
};

const getters = {
  // Step 1 Getters
  typeOptions: state => state.typeOptions,
  roleOptions: state => state.roleOptions,
  competencyOptions: state => state.competencyOptions,
  matrixKPLHOptions: state => state.matrixKPLHOptions,
  isLoadingRoles: state => state.isLoadingRoles,
  isLoadingCompetencies: state => state.isLoadingCompetencies,

  // Step 2 Getters
  courseTypeOptions: state => state.courseTypeOptions,
  categoryOptions: state => state.categoryOptions,
  stemMainOptions: state => state.stemMainOptions,
  stemSubOptions: state => state.stemSubOptions,
  yearOptions: state => state.yearOptions,
  monthOptions: state => state.monthOptions,
  isLoadingCourseTypes: state => state.isLoadingCourseTypes,
  isLoadingCategories: state => state.isLoadingCategories,

  // Step 3 Getters
  platformOptions: state => state.platformOptions,
  lspOptions: state => state.lspOptions,
  trainingProviderOptions: state => state.trainingProviderOptions,
  isLoadingLSP: state => state.isLoadingLSP,
  isLoadingTrainingProvider: state => state.isLoadingTrainingProvider,

  // Step 4 Getters
  departmentOptions: state => state.departmentOptions,
  divisionOptions: state => state.divisionOptions,
  organizationLevelOptions: state => state.organizationLevelOptions,
  isLoadingDepartments: state => state.isLoadingDepartments,
  isLoadingDivisions: state => state.isLoadingDivisions,
  isLoadingOrganizationLevels: state => state.isLoadingOrganizationLevels,
};

const mutations = {
  // Step 1 Mutations
  SET_ROLE_OPTIONS(state, data) {
    state.roleOptions = data;
  },
  SET_COMPETENCY_OPTIONS(state, data) {
    state.competencyOptions = data;
  },
  SET_LOADING_ROLES(state, status) {
    state.isLoadingRoles = status;
  },
  SET_LOADING_COMPETENCIES(state, status) {
    state.isLoadingCompetencies = status;
  },

  // Step 2 Mutations
  SET_COURSE_TYPE_OPTIONS(state, data) {
    state.courseTypeOptions = data;
  },
  SET_CATEGORY_OPTIONS(state, data) {
    state.categoryOptions = data;
  },
  SET_LOADING_COURSE_TYPES(state, status) {
    state.isLoadingCourseTypes = status;
  },
  SET_LOADING_CATEGORIES(state, status) {
    state.isLoadingCategories = status;
  },

  // Step 3 Mutations
  SET_LSP_OPTIONS(state, data) {
    state.lspOptions = data;
  },
  SET_TRAINING_PROVIDER_OPTIONS(state, data) {
    state.trainingProviderOptions = data;
  },
  SET_LOADING_LSP(state, status) {
    state.isLoadingLSP = status;
  },
  SET_LOADING_TRAINING_PROVIDER(state, status) {
    state.isLoadingTrainingProvider = status;
  },

  // Step 4 Mutations
  SET_DEPARTMENT_OPTIONS(state, data) {
    state.departmentOptions = data;
  },
  SET_DIVISION_OPTIONS(state, data) {
    state.divisionOptions = data;
  },
  SET_ORGANIZATION_LEVEL_OPTIONS(state, data) {
    state.organizationLevelOptions = data;
  },
  SET_LOADING_DEPARTMENTS(state, status) {
    state.isLoadingDepartments = status;
  },
  SET_LOADING_DIVISIONS(state, status) {
    state.isLoadingDivisions = status;
  },
  SET_LOADING_ORGANIZATION_LEVELS(state, status) {
    state.isLoadingOrganizationLevels = status;
  },
};

const actions = {
  // ==================== Step 1 Actions ====================
  async fetchRoleCompetencies({ commit }) {
    commit('SET_LOADING_ROLES', true);
    try {
      const params = 'page=1&per_page=100';
      const response = await GET_ROLE_COMPETENCIES(params);
      
      if (response.data && response.data.data && response.data.data.data) {
        const roleOptions = response.data.data.data.map(item => ({
          label: item.role_competency_name,
          value: item.id
        }));
        commit('SET_ROLE_OPTIONS', roleOptions);
      }
    } catch (error) {
      console.error('Error fetching role competencies:', error);
      throw error;
    } finally {
      commit('SET_LOADING_ROLES', false);
    }
  },

  async fetchCompetencies({ commit }) {
    commit('SET_LOADING_COMPETENCIES', true);
    try {
      const params = {
        page: 1,
        per_page: 100
      };
      const response = await GET_COMPETENCIES(params);
      
      if (response.data && response.data.data && response.data.data.data) {
        const competencyOptions = response.data.data.data.map(item => ({
          label: item.name,
          value: item.id,
        }));
        commit('SET_COMPETENCY_OPTIONS', competencyOptions);
      }
    } catch (error) {
      console.error('Error fetching competencies:', error);
      throw error;
    } finally {
      commit('SET_LOADING_COMPETENCIES', false);
    }
  },

  // ==================== Step 2 Actions ====================
  async fetchCourseTypes({ commit }) {
    commit('SET_LOADING_COURSE_TYPES', true);
    try {
      const response = await GET_TRAINING_TYPE();
      
      if (response.data && response.data.data) {
        const courseTypeOptions = response.data.data.map(item => ({
          label: item.name,
          value: item.id,
        }));
        commit('SET_COURSE_TYPE_OPTIONS', courseTypeOptions);
      }
    } catch (error) {
      console.error('Error fetching course types:', error);
      throw error;
    } finally {
      commit('SET_LOADING_COURSE_TYPES', false);
    }
  },

  async fetchCategories({ commit }) {
    commit('SET_LOADING_CATEGORIES', true);
    try {
      const params = {
        page: 1,
        per_page: 100
      };
      const response = await trainingCategoryAPI.getTrainingCategories(params);
      
      if (response.data && response.data.data && response.data.data.data) {
        const categoryOptions = response.data.data.data.map(item => ({
          label: item.title,
          value: item.id || item.id,
        }));
        commit('SET_CATEGORY_OPTIONS', categoryOptions);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    } finally {
      commit('SET_LOADING_CATEGORIES', false);
    }
  },

  // ==================== Step 3 Actions ====================
  async fetchLSP({ commit }) {
    commit('SET_LOADING_LSP', true);
    try {
      const params = {
        page: 1,
        per_page: 100
      };
      const response = await GET_LSP(params);
      
      if (response.data && response.data.data && response.data.data.data) {
        const lspOptions = response.data.data.data.map(item => ({
          label: item.name,
          value: item.id,
          code: item.code || ''
        }));
        commit('SET_LSP_OPTIONS', lspOptions);
      }
    } catch (error) {
      console.error('Error fetching LSP:', error);
      throw error;
    } finally {
      commit('SET_LOADING_LSP', false);
    }
  },

  async fetchTrainingProvider({ commit }) {
    commit('SET_LOADING_TRAINING_PROVIDER', true);
    try {
      const params = {
        page: 1,
        per_page: 100
      };
      const response = await GET_TRAINING_PROVIDER(params);
      
      if (response.data && response.data.data && response.data.data) {
        const trainingProviderOptions = response.data.data.map(item => ({
          label: item.name,
          value: item.id,
          code: item.code || ''
        }));
        
        // Add "Other" option at the end
        trainingProviderOptions.push({
          label: 'Other',
          value: 'other',
          code: ''
        });
        
        commit('SET_TRAINING_PROVIDER_OPTIONS', trainingProviderOptions);
      }
    } catch (error) {
      console.error('Error fetching training provider:', error);
      throw error;
    } finally {
      commit('SET_LOADING_TRAINING_PROVIDER', false);
    }
  },

  // ==================== Step 4 Actions ====================
  async fetchDepartments({ commit }, division) {
    commit('SET_LOADING_DEPARTMENTS', true);
    try {
      const response = await filterAPI.getDepartments(division);
      
      if (response.data && response.data.data) {
        const departmentOptions = response.data.data.map(item => ({
          label: item.department,
          value: item.department,
        }));
        commit('SET_DEPARTMENT_OPTIONS', departmentOptions);
      }
    } catch (error) {
      console.error('Error fetching departments:', error);
      throw error;
    } finally {
      commit('SET_LOADING_DEPARTMENTS', false);
    }
  },

  async fetchDivisions({ commit }, department) {
    commit('SET_LOADING_DIVISIONS', true);
    try {
      const response = await filterAPI.getDivisions(department);
      
      if (response.data && response.data.data) {
        const divisionOptions = response.data.data.map(item => ({
          label: item.division,
          value: item.division,
        }));
        commit('SET_DIVISION_OPTIONS', divisionOptions);
      }
    } catch (error) {
      console.error('Error fetching divisions:', error);
      throw error;
    } finally {
      commit('SET_LOADING_DIVISIONS', false);
    }
  },

  async fetchOrganizationLevels({ commit }, isPartnerOnly = false) {
    commit('SET_LOADING_ORGANIZATION_LEVELS', true);
    try {
      const params = {};
      if (isPartnerOnly) {
        params.is_partner = true;
      }
      
      const response = await positionLevelAPI.getPositionLevels(params);
      
      if (response.data && response.data.data.data) {
        const organizationLevelOptions = response.data.data.data.map(item => ({
          label: item.name,
          value: item.id,
        }));
        commit('SET_ORGANIZATION_LEVEL_OPTIONS', organizationLevelOptions);
      }
    } catch (error) {
      console.error('Error fetching organization levels:', error);
      throw error;
    } finally {
      commit('SET_LOADING_ORGANIZATION_LEVELS', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
